<template>
    <div>
    <h2> Plane of Fire:</h2>
    Download Annotated Map:
    <a @click="$emit('downloadImg', 'Plane Of Fire')">Download</a><br/>
    Download Clean Map:
    <a href="https://s3.amazonaws.com/files.d20.io/images/230369559/u1glosYEmekWzM-Vv-rICw/original.jpg?162456655555" target="_blank">Map</a><br/>
    The plane of fire is the high difficulty encounter with a CR of 9 on floor 2. It is arena style, so monsters will spawn one after another.
    <v-row>
        <v-col>
            <img id="Plane Of Fire" :src="require('../../../assets/Annotated_Fire_Map.png')"  contain height="942px"/>
        </v-col>
        <v-col>
        <h4>Map Details: </h4>
        <ul>
            <li>This encounter takes place in a cave in the plane of fire. However since this is only a memory of the plane of fire the usual effects of the plane of fire will not affect the party or any creatures, such as enhanced or impeded magic.</li>
            <li>The area is brightly lit and players can see the whole map</li>
            <li>The ceiling is an unmeasurable height, however if players ascend more than 50 feet they must make a fortitude save dc 16, +2 for every 10 feet above 50 feet they are, +1 per previous check, or they become nauseated from smoke inhalation. If they fail the DC goes up by 4, and if they fail 3 times in a row they fall unconcious for 1d4 rounds and take 4d6 damage each round unconcious.</li>
            <li>Map is 25x25</li>
            <li><b>Color Code:</b></li>
            <ul>
                <li>Player Spawn: Pink</li>
                <li>Treasure: Green</li>
                <li>Monster Spawns: Cyan</li>
                <li>Terrain of Note: White</li>
            </ul>
            <li><b>Rule Reminders:</b></li>
            <ul>
                <li>Jumping over cliffs:</li>
                <ul>
                    <li>Acrobatics check DC = distance in feet. </li>
                    <li>Gain a +-4 to acrobatics checks for every 10 feet faster or slower than 30 feet your movement speed is, no acrobatics check can allow you to exceed your movement speed</li>
                    <li>If you fail an acrobatics check by 4 or less you can attempt a reflex save DC 20 to grab onto the ledge, and a DC 15 climb check to pull yourself up on the following round.</li>
                    <li>If you don't have 10 or more feet of running start double acrobatics check DCs</li>
                    <li>If a player fails their acrobatics check by 4 or less, and fail their reflex save by 8 or less they receive damage as if they had contact with lava, and must make two dc 15 climb checks as movement actions to get back onto land, if they fail by 9 or more they receive damage as if total immersion in lava, and must make two DC 15 climb checks as movement actions to get onto land.</li>
                </ul>
                <li>Lava deals 2d6 on contact, and 1d6 for the next 1d3 rounds. Total immersion damage has been reduced to deal 10d6 on the round immersed, and 5d6 for 1d3 rounds.</li>                
            </ul>
        </ul>
        <br/><br/>        
                
        </v-col>
    </v-row>

    
    <h4>Monsters:</h4>
        <ul>
            <li><b>Wave 1 CR 9: </b> </li>
             First wave appears the moment players enter arena            
            <ul>
                <li><b>1) Flame Drake CR 5: </b> Appears at spawnpoint 4 from the smoke above. Will use its fireball breath and then decend to attack players on the next round.</li>
                <li><b>2) Large Magma Elemental CR 5:</b> Tunnels from the ground at spawnpoint 5(alt 3)</li>
                <li><b>3) Huge Fire Elemental CR 5: </b> Erupts from the lava at spawnpoint 1</li>
            </ul>            
            <br/>
            <li><b>Wave 2 CR 10: </b> </li>
            Wave 2 begins once 2/3 monsters from wave 1 are slain
            <ul>
                <li><b>1) Fire Giant CR 10: </b> walks around a corner and enters from spawn 5 (Alt 6) </li>
            </ul>
            <br/>
            <li><b>Wave 3 CR 11: </b> </li>
            Wave 3 begins once fire giant is slain. Players hear what sounds like crying echoing across the chamber over the sound of lava eruptions.
            <ul>
                <li><b>1) Burning Child CR 10: </b> enters from spawnpoint 1,2, or 7, whichever is furthest from a player. The Burning Child will stay invisible and incorporeal and move to try and hit as many players as it can with its breath weapon, and becomes corporeal and visible to do so. Final Embrace does work on a Burning child, but players must first learn of this weakness with a usual DC 35 knowledge planes check. On rounds it is currently embraced on it takes no actions other than slamming player embracing it.</li>
                <li><b>2) Efreeti CR 8: </b> Erupts from a fiery explosion at spawnpoint 5(alt 6) Attempts to engage in melee as fast as possible, using its quickened scorching rays in combat.</li>
            </ul>
            <br/>
            <li><b>Wave 4 CR 13: </b> </li>
            Begins one full round after all monsters from wave 3 are dead. Players hear a roaring overhead on first round, then on the second monsters engage.
            <ul>
                <li><b>Adult Magma Dragon CR 12: </b> Appears in the air over spawnpoint 8, flying for 1 round, using a fireball, then landing to engage the party. Appears after having already cast shield on itself.</li>
                <li><b>Greater Fire Elemental CR 9: </b> Erupts from the lava at spawnpoint 7</li>
                <li><b>Greater Magma Elemental CR 9: </b>Walks in from spawnpoint 1 or 6, whichever is further from a player.</li>
            </ul>
            <br/>
            <li><b>Wave 5 CR 14: </b> </li>
            Wave 5 begins 3 full rounds after the adult magma dragon or both greater elementals in wave 4 or slain. 
            <ul>
                <li><b>Cherufe CR 13: </b> Walks in from spawnpoint 7 or 1, whichever is further from players. Attempts to fight players from within lava to gain temporary health each round. Counts only as contacting lava each round because of its size.</li>
                <li><b>2x Fire Giants CR 10: </b> One spawns from spawnpoint 5, and the other from spawnpoint 6. Both walking into area from outside map.</li>
            </ul>
        </ul>
        <br/><br/>

        <h4>Treasure:</h4>
        <ul>
            <li><b>1) Level Up 200</b></li>
            <li><b>2) Resurrective 75</b></li>
            <li><b>3) E+ Stats 25</b></li>
            <li><b>4) LVL+ Damage Spell/Regular Maneuver 20</b></li>
            <li><b>5) Enchanted R+ Weapon 75</b></li>
            <li><b>6) R+ stats 25</b></li>
            <li><b>7) Stats 25</b></li>
            <li><b>8) Feat 100</b></li>
            <li><b>9) 4-8 Potions 25</b></li>
            <li><b>10) R+ Weapon Enchantment 100</b></li>
            <li><b>11) LVL+ Damage Spell/Regular Maneuver 20</b></li>
            <li><b>12) Spell/Maneuver 20</b></li>
            <li><b>13) E+ Typed Weapon</b></li>
            <li><b>14) R+ Weapon Enchantment 100</b></li>
            <li><b>15) 4-8 Potions 25</b></li>
            <li><b>16) R+ Armor Enchantment</b></li>
            <li><b>16) Stats 25</b></li>
            <li><b>18) R+ Perk 125</b></li>
            <li><b>C) Level Up Cursed Chest: </b> If players activate cursed chest it spawns a young gold dragon, and rewards a level up if it is defeated.</li>

        </ul>
        <br/><br/>
        <h4>Terrain of Note: </h4>
        <ul>
            <li><b>1) Large Cliff: </b> This cliff ascends 20 feet.</li>
            
        </ul>
        <br/><br/>
    </div>
</template>
            
<script>
import {
VRow,
VCol,
} from "vuetify/lib";
export default {
  components: {    
    VRow,
    VCol,
  },
  data(){
    return{
        
    }
  },
  methods:{

  }
}
</script>